module.exports = __webpack_public_path__ + "assets/Angle15Detailed.201b69de6426ec18080ee62f1a599b51.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/1x/Angle15Detailed.png
// module id = 458
// module chunks = 0